import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/components/common/empty-state';

/**
 * Page displayed when user attempts to access a route they don't have permission for
 * Shows a message directing them to contact an administrator for access
 */
export const ForbiddenPage = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex h-full items-center justify-center p-6">
      <EmptyState
        icon={ShieldAlert}
        title={t('forbidden.title')}
        description={t('forbidden.description')}
      />
    </div>
  );
};
